import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/resource-capacity", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/resource-capacity/csv", params);
};

const get = id => {
  return restApi.get(`/api/resource-capacity/${id}`);
};

const upsert = data => {
  return restApi.post("/api/resource-capacity/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/resource-capacity/${ids}`);
};

const resourceCapacityService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default resourceCapacityService;